import { failMuseums, fetchMuseumsPromise, receiveMuseums } from "./museums-action";
import { itemsById } from "@kulturit/items-by-id";
import { fetchUserdataPromise, receiveUserdata, resetUserdata } from "./userdata-action";
import { applicationsReceived, fetchApplicationsPromise } from "./apps-action";
import { receiveGlobalApp, receiveMuseumApp } from "./authz-action";

export var APPS_NAV_DATA_REQUESTED = 'appsNav/dataRequested';
export var OWNER_SELECTED_BY_ID = 'appsNav/ownerSelectedById';

export var fetchAppsNavData = function fetchAppsNavData(appId) {
    return function (dispatch) {
        dispatch(appsNavDataRequested());
        Promise.all([fetchMuseumsPromise(dispatch).catch(function (error) {
            return { error: error, code: error };
        }), fetchApplicationsPromise(dispatch), fetchUserdataPromise(dispatch).catch(function (error) {
            return { error: error, code: error };
        })]).then(function (_ref) {
            var museumsJson = _ref[0],
                appsJson = _ref[1],
                userdataJson = _ref[2];

            if (museumsJson.hasOwnProperty('error')) {
                dispatch(failMuseums());
                return;
            }

            if (userdataJson.hasOwnProperty('error')) {
                if (401 === userdataJson.code) {
                    dispatch(resetUserdata());
                }
                return;
            }

            var museumsById = itemsById(museumsJson.museums).items;
            dispatch(receiveMuseums(museumsById, museumsJson.museums));

            var applicationsById = itemsById(appsJson).items;
            dispatch(applicationsReceived(applicationsById, appsJson));
            dispatch(receiveUserdata(userdataJson, museumsById, applicationsById));

            if (appId) {
                var globalAppAccess = userdataJson.appAccess.apps.filter(function (app) {
                    return app.id === appId;
                });
                var museumAppAccess = userdataJson.appAccess.museums.filter(function (museum) {
                    return museum.applications.filter(function (app) {
                        return function (app) {
                            return app.id === appId;
                        };
                    });
                });

                if (globalAppAccess[0]) {
                    dispatch(receiveGlobalApp(globalAppAccess[0]));
                } else if (museumAppAccess[0]) {
                    dispatch(receiveMuseumApp());
                }
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
};

var appsNavDataRequested = function appsNavDataRequested() {
    return {
        type: APPS_NAV_DATA_REQUESTED
    };
};

export var selectOwnerById = function selectOwnerById(ownerId) {
    return function (dispatch) {
        dispatch({
            type: OWNER_SELECTED_BY_ID,
            ownerId: ownerId
        });
    };
};